import { useState } from "react";
import './NavBar.less'
import { Image } from 'antd-mobile';
import { useHistory } from 'react-router-dom'
import { onReturn } from '@/utils/common'

const NavBar = (props:any) => {
  const [history] = useState(useHistory())

  const handleClick = () => {
    if (history.length > 1) {
      try {
        history.goBack()
      } catch(e) {
        onReturn()
      }
    }
    else onReturn()
  }

  return (
    <nav className="nav-bar-header">
      <div onClick={() => props.leftButton ? props.leftButton() : handleClick()}>
        <span className="back-arrow" />
      </div>
      <header>{props.title}</header>
      <div onClick={props?.buttonClick}>
        {props?.imageUrl ? <Image src={props?.imageUrl} fit='contain' alt="" width={16} height={16}/>: ''}
        <span>{props.rightButton}</span>
      </div>
     
    </nav>
  );
}

export default NavBar